import { MemberGroups, AccountType } from "shared-types";

export enum UserAttributes {
  FullName = "full_name",
  Email = "email",
  UserIdAgent = "agent_id",
  UserIdCasting = "casting_id",
  UserIdPerformer = "artist_id",
  ProfileId = "profile_id",
  MasterPortalGuid = "sub",
  IdentityProvider = "idp",
  MemberGroup = "spotlight.MemberGroups",
  Subscriptions = "subscriptions",
  Role = "role",
  PublicationCode = "publication",
  AgencyPermissions = "agencyPermissions",
}

export enum CastingDirectorMemberGroup {
  CastingDirector = "castingDirector",
  CastingBBC = "castingDirectorBBC",
  CastingDirectorSearchOnly = "castingDirector:searchOnlyCastingDirector",
}

export enum CastingDirectorUserSubscription {
  SubscriptionFamily = "subscriptionfamily",
}

export const UserGroupAccountTypeMap = {
  [MemberGroups.defaultUser]: AccountType.DefaultUser,
  [MemberGroups.performer]: AccountType.Performer,
  [MemberGroups.graduatePerformer]: AccountType.Performer,
  [MemberGroups.yPerformer]: AccountType.Performer,
  [MemberGroups.agent]: AccountType.Agent,
  [MemberGroups.castingDirector]: AccountType.CastingDirector, // castingDirectorBBC and castingDirectorSearchOnly are considered same role
  [MemberGroups.searchOnlyCD]: AccountType.CastingSearchOnly,
  [MemberGroups.castingBBC]: AccountType.CastingSearchOnly,
};

export const SPOTLIGHT_PORTAL_ID_COOKIE = "spotlight.user";

export const SL_MEMBER_GROUP = "spotlight.MemberGroups";

export const SIGN_IN_CALLBACK_URL = "signin-oidc";

export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";
